import { useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { orderContext } from '../OrderContext';
import Moment from 'react-moment';
import ReferenceDataKey from 'helpers/enums/ReferenceDataKey';
import { applicationContext } from 'helpers/services';
import { DetailsPageHeader } from 'components';


let OrderDetails = () => {
    let service = useContext(orderContext);
    let appService = useContext(applicationContext);

    return (
        <DetailsPageHeader sectionName='Order details'>
            <Grid container>
                <Grid item xs={3}>
                    <Typography>Status</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>{appService.referenceData[ReferenceDataKey.OrderStatus].getValueByKey(service.order.orderStatus) ?? ""}</Typography>
                </Grid>
                <Grid item xs={3}>
                    Date
                </Grid>
                <Grid item xs={9}>
                    {service.order.orderDate &&
                        <Moment date={service.order.orderDate} format="LLL" />
                    }
                    {!service.order.orderDate &&
                        '-'
                    }
                </Grid>
                <Grid item xs={3}>
                    <Typography>DUE order number</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>{service.order.erpOrderNumber}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Customer order number</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>{service.order.customerOrderNumber}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Shipment code</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>{service.order.shipmentCode}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Sport tech</Typography>
                </Grid>
                <Grid item xs={9}>
                    {service.order.containsSportTechBrands === false && <Typography>No sport tech products in this order</Typography>}
                    {service.order.containsSportTechBrands === true && service.order.allSportTechBrands === false && <Typography>Mixed products in this order</Typography>}
                    {service.order.containsSportTechBrands === true && service.order.allSportTechBrands === true && <Typography>All sport tech products in this order</Typography>}
                </Grid>
            </Grid>
        </DetailsPageHeader>
    );
}

export default OrderDetails;